<template>
	<svg
		width="16"
		height="12"
		viewBox="0 0 16 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.6993 3.5408L8.19871 0.290558C8.07186 0.235585 7.92791 0.235585 7.80105 0.290558L0.300498 3.5408C-0.100282 3.71447 -0.100376 4.28473 0.300498 4.4584L2.99951 5.62795V8.74994C2.99951 10.4323 5.19592 11.7502 7.99988 11.7502C10.8038 11.7502 13.0003 10.4323 13.0003 8.74994V5.62795L13.5003 5.41128V10.7501C13.5003 11.0262 13.7242 11.2501 14.0003 11.2501C14.2765 11.2501 14.5004 11.0262 14.5004 10.7501V4.97794L15.6993 4.45843C16.1 4.28476 16.1001 3.7145 15.6993 3.5408ZM7.99988 1.29432L14.2428 3.99961L13.7477 4.21416L8.06189 3.50342C7.78784 3.46939 7.53794 3.66356 7.50369 3.93758C7.46944 4.2116 7.66383 4.46152 7.93785 4.49578L11.9426 4.99638L7.99988 6.70488C4.47284 5.17648 5.22405 5.50201 1.75695 3.99958L7.99988 1.29432ZM12.0002 8.74997C12.0002 9.2211 11.6135 9.70616 10.9393 10.0807C9.33348 10.9728 6.67097 10.9754 5.06051 10.0807C4.38627 9.70616 3.99959 9.2211 3.99959 8.74997V6.06136L7.80105 7.70867C7.92769 7.76355 8.07161 7.76374 8.19871 7.70867L12.0002 6.06136V8.74997Z"
			fill="#FA0B76"
		/>
	</svg>
</template>
<script>
export default {
	name: 'IconStudy',
}
</script>
